import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=d7666eee&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7666eee')) {
      api.createRecord('d7666eee', component.options)
    } else {
      api.reload('d7666eee', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=d7666eee&", function () {
      api.rerender('d7666eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M9bl5iNKbb38/JS/comp/childrenage.vue"
export default component.exports